import { gql } from '@apollo/client';

const schema = {
  list: {
    name: "actionNew",
    serviceName: "graphql",
    query: gql`
      query actionNew(
        $ids: [String]
        $title: String
        $depth: Int
        $for_admin: Int
        $category_id: String
        $orderBy_field: String
        $walk_direction: String
        $orderBy_direction: String
      ) {
        actionNew(
          ids: $ids
          title: $title
          depth: $depth
          for_admin: $for_admin
          category_id: $category_id
          orderBy_field: $orderBy_field
          walk_direction: $walk_direction
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
            alias
            parent {
              id
              title
            }
            media {
              id
              full_url
              collection_name
            }
            children {
              id
              title
              alias
              parent {
                id
                title
              }
              media {
                id
                full_url
                collection_name
              }
              children {
                id
              }
            }
          }
        }
      }
    `,
  },
  current: {
    name: "actionNew",
    serviceName: "graphql",
    query: gql`
      query actionNew($ids: [String]) {
        actionNew(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: "productCategoryPaginate",
    serviceName: "graphql",
    query: gql`
      query productCategoryPaginate($ids: [String]) {
        productCategoryPaginate(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
